import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Home, Sparkles } from 'lucide-react';
const benefits = [{
  icon: Heart,
  title: 'Aprendé algo lindo y útil',
  desc: 'Descubrí una actividad creativa, relajante y llena de posibilidades para hacer con tus propias manos.'
}, {
  icon: Home,
  title: 'Generá ingresos extra desde casa',
  desc: 'Convertí tus creaciones en regalos, souvenirs o productos personalizados para vender.'
}, {
  icon: Sparkles,
  title: 'Empezá aunque seas principiante',
  desc: 'No necesitás experiencia previa. La guía está diseñada para acompañarte paso a paso desde cero.'
}];
export function Benefits() {
  return <section className="py-8 sm:py-10 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-14">
      <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-10 px-2" data-id="element-15">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl text-deco-text mb-4 sm:mb-6 font-bold leading-tight" data-id="element-16">
          ¿Sentís que es momento de crear algo propio?
        </h2>
        <p className="text-base sm:text-lg text-deco-taupe font-medium" data-id="element-17">
          Con la Mega Guía tenés una forma simple, creativa y práctica de
          aprender a crear piezas deco desde casa, incluso si empezás desde
          cero.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 max-w-5xl mx-auto" data-id="element-18">
        {benefits.map((benefit, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: i * 0.1
      }} className="bg-deco-card rounded-[2rem] p-8 sm:p-10 shadow-sm border border-deco-warm hover:shadow-md transition-shadow flex flex-col items-center text-center relative overflow-hidden" data-id="element-19">
            <div className="absolute top-0 right-0 w-32 h-32 bg-deco-bg rounded-bl-full -z-10 opacity-50" data-id="element-20"></div>

            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-deco-bg flex items-center justify-center mb-6 text-deco-terra border border-deco-warm" data-id="element-21">
              <benefit.icon size={28} className="sm:w-8 sm:h-8" strokeWidth={1.5} data-id="element-22" />
            </div>
            <h3 className="text-xl sm:text-2xl mb-3 sm:mb-4 text-deco-text font-serif font-bold leading-tight" data-id="element-23">
              {benefit.title}
            </h3>
            <p className="text-deco-text/70 leading-relaxed font-normal text-sm sm:text-base" data-id="element-24">
              {benefit.desc}
            </p>
          </motion.div>)}
      </div>
    </section>;
}